"use strict";

/**
 *
 * Handles the visibility of the personal info at the profile desctiption.
 *
 */

/**
 *
 * Show the personal info section only when there is only one person.
 * Disables the personal info fields.
 *
 */
function handlePersonalInfoInputs() {
  const numberOfPeople = Number($("#number_of_persons").val());
  const shouldBeVisible = numberOfPeople === 1;

  $(".js-personal-info").attr("hidden", !shouldBeVisible);

  // QUESTION: should I disable them?
  $(".js-personal-info")
    .find("input")
    .attr("disabled", !shouldBeVisible);
  $(".js-personal-info")
    .find("input")
    .attr("hidden", !shouldBeVisible);
}

function onLoad() {
  const forceDisabled =
    $("#number_of_persons").attr("data-forcedisabled") === "true";
  if (!forceDisabled) {
    handlePersonalInfoInputs();
    $("#number_of_persons").on("input paste keydown", function() {
      handlePersonalInfoInputs();
    });
  }
}

module.exports = {
  onLoad
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-profile-description-ui/booking-profile-description-ui.js